import {cn} from '@/lib/utils'
import React from 'react'

export interface IWuMenuIconProps extends React.HTMLAttributes<HTMLDivElement> {
  showMenu?: boolean
  color?: string
}

export const WuMenuIcon = React.forwardRef<HTMLDivElement, IWuMenuIconProps>(
  ({showMenu = false, className, color = '#1B3380', ...props}, ref) => {
    const barClassName = cn('w-full border transition-all duration-300')

    return (
      <div
        {...props}
        className={cn(
          'flex flex-col w-[18px] justify-between aspect-[3/2] transition-all duration-300',
          className,
        )}
        ref={ref}
        aria-label="menu-icon"
      >
        <div
          className={`${barClassName} origin-center ${
            showMenu ? 'rotate-45 translate-y-[5px]' : ''
          }`}
          style={{borderColor: color}}
        />
        <div
          className={`${barClassName} ${showMenu ? 'opacity-0' : ''}`}
          style={{borderColor: color}}
        />
        <div
          className={`${barClassName} origin-center ${
            showMenu ? '-rotate-45 -translate-y-[5px]' : ''
          }`}
          style={{borderColor: color}}
        />
      </div>
    )
  },
)

WuMenuIcon.displayName = 'WuMenuIcon'
